"use client";
import Navbar from '../../components/Navbar';
import Footer from '../../components/Footer';
import SectionTitle from '../../components/SectionTitle';
import { useRef, useState } from 'react';


export default function ContactPage() {
  const form = useRef<HTMLFormElement>(null);
  const [status, setStatus] = useState("");
  const [loading, setLoading] = useState(false);

  const sendEmail = async (e: React.FormEvent) => {
    e.preventDefault();
    setStatus("");
    setLoading(true);
    if (form.current) {
      const formData = new FormData(form.current);
      const data = {
        name: formData.get("name"),
        email: formData.get("email"),
        message: formData.get("message"),
      };
      try {
        const res = await fetch("/api/contact-email", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(data),
        });
        if (res.ok) {
          setStatus("Message sent successfully!");
          form.current.reset();
        } else {
          setStatus("Failed to send message. Please try again.");
        }
      } catch {
        setStatus("Failed to send message. Please try again.");
      }
      setLoading(false);
    }
  };

  return (
    <div className="flex flex-col min-h-screen bg-gray-50">
      <Navbar />
      {/* Hero Section */}
      <section className="relative bg-blue-900 text-white py-16 mb-8">
        <div className="container mx-auto px-4 flex flex-col items-center">
          <h1 className="text-4xl font-extrabold mb-4 drop-shadow-lg">Contact Us</h1>
          <p className="max-w-2xl text-lg mb-6 opacity-90 text-center">
            We’d love to hear from you! Reach out for support, partnership, or to learn more about Somali Eye Care.
          </p>
        </div>
        <div className="absolute bottom-0 left-0 w-full h-4 bg-gradient-to-r from-blue-700 to-blue-400 opacity-40" />
      </section>

      <main className="flex-1">
        <div className="container mx-auto px-4 py-12">
          <div className="max-w-3xl mx-auto mb-12 text-center">
            <SectionTitle>Get in Touch</SectionTitle>
            <p className="text-gray-700 text-lg mb-2">Fill out the form or use the contact details below. We’ll respond as soon as possible.</p>
            <hr className="my-6 border-blue-200" />
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {/* Contact Form */}
            <form ref={form} onSubmit={sendEmail} className="bg-white rounded-lg shadow-lg p-8 flex flex-col">
              <label className="font-semibold mb-2 text-blue-700">Name</label>
              <input name="name" type="text" className="mb-4 p-3 rounded border border-gray-300 focus:border-blue-500 focus:outline-none transition bg-white text-gray-900 placeholder-gray-500" placeholder="Your Name" required />
              <label className="font-semibold mb-2 text-blue-700">Email</label>
              <input name="email" type="email" className="mb-4 p-3 rounded border border-gray-300 focus:border-blue-500 focus:outline-none transition bg-white text-gray-900 placeholder-gray-500" placeholder="Your Email" required />
              <label className="font-semibold mb-2 text-blue-700">Message</label>
              <textarea name="message" className="mb-4 p-3 rounded border border-gray-300 focus:border-blue-500 focus:outline-none transition bg-white text-gray-900 placeholder-gray-500" rows={5} placeholder="Your Message" required></textarea>
              <button type="submit" className="bg-blue-600 text-white py-2 px-6 rounded shadow hover:bg-blue-700 font-semibold transition flex items-center justify-center" disabled={loading}>
                {loading ? (
                  <svg className="animate-spin h-5 w-5 mr-2 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z"></path>
                  </svg>
                ) : null}
                Send Message
              </button>
              {status && <p className="mt-4 text-green-600 font-semibold">{status}</p>}
            </form>
            {/* Contact Info */}
            <div className="flex flex-col justify-center bg-blue-50 rounded-lg shadow-lg p-8">
              <div className="mb-6">
                <span className="font-bold text-blue-900">Email:</span> <a href="mailto:info@somalieyecare.org.so" className="underline text-blue-700 hover:text-blue-500">info@somalieyecare.org.so</a>
              </div>
              <div className="mb-6">
                <span className="font-bold text-blue-900">Address:</span> <span className="text-gray-800">Hodan Taleex, Mogadishu, Somalia</span>
              </div>
              <div className="mb-6">
                <span className="font-bold text-blue-700">Map:</span>
                <div className="w-full h-40 rounded border border-blue-200 overflow-hidden">
                  <iframe
                    title="Mogadishu Map"
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3976.682073964479!2d45.31816247499344!3d2.046934397963342!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3d58ddc1e2e2e2e3%3A0x7e7e7e7e7e7e7e7e!2sMogadishu%2C%20Somalia!5e0!3m2!1sen!2sso!4v1692890000000!5m2!1sen!2sso"
                    width="100%"
                    height="100%"
                    style={{ border: 0 }}
                    allowFullScreen={true}
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                  ></iframe>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
